import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  SectionElement,
} from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<SectionElement>["defaultData"] = {
  attributes: {
    "background-repeat": "repeat",
    "background-size": "auto",
    "background-position": "top center",
    direction: "ltr",
    padding: "20px 0",
    "padding-top": "20px",
    "padding-right": "0px",
    "padding-bottom": "20px",
    "padding-left": "0px",
    "text-align": "center",
  },
  data: {},
};

export const Section = createBlock<SectionElement>({
  get name() {
    return t("Row");
  },
  defaultData,
  type: BasicType.SECTION,
  create: (payload) => {
    const defaultData: SectionElement = {
      type: BasicType.SECTION,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SECTION,
  render(params) {
    return <BasicBlock params={params} tag="mj-section" />;
  },
});
